module.exports = __webpack_public_path__ + "img/search-service-temp.285d0a7f.png";